import * as process from 'process';

export const APPCONFIG = {
	baseUrl: process.env.REACT_APP_API_URL,
	apiVersion: process.env.REACT_APP_API_VERSION,
	appName: process.env.REACT_APP_NAME,
	authBaseUrl: process.env.REACT_APP_AUTH_API_URL,
};
